module.exports = __webpack_public_path__ + "static/dash-2-70e3ada87157cd4f27e77bb43fcaffda.png";